import React, { useState, useEffect, useMemo } from 'react'
import { isEmpty, isEqual } from 'lodash'
import { renderField } from '../utils'
import {
  ANALYSIS_MODE,
  CHART_DEFINITION_FIELDS
} from '../../chartConfigurationsV2'
import { Select } from './Select'
import { ItemConfigRow } from './ItemConfigRow'
import { TextColorInput } from './CustomChartInputs'
import { THEME_COLOR_SWATCH } from 'utils/constants'

export const ColorTiers = ({ workspace, field, onChange, value, streams, chartType, color }) => {
  // Color tiers are not applicable to Pie and Doughnut charts
  if (chartType === 'pie' || chartType === 'doughnut') {
    return null
  }

  const updateColorTiers = (index, val) => {
    const updatedValue = {
      ...value,
      customConfigs: value.customConfigs.map((customConfig, i) => {
        if (i === index) {
          return {
            ...customConfig,
            ...val
          }
        }
        return customConfig
      })
    }
    onChange(updatedValue)
  }

  const updateColorCount = (val) => {
    const tierCount = parseInt(val.value)
    const updatedValue = {
      ...field,
      customConfigs: Array.from(Array(tierCount)).map((item, colorIndex) => {
        // Check if existing config exists, otherwise create new one
        const existingConfig = value?.customConfigs?.[colorIndex] || {}

        return {
          color: existingConfig?.color || THEME_COLOR_SWATCH[colorIndex % THEME_COLOR_SWATCH.length],
          value: existingConfig?.value || calculateThresholdValue(colorIndex, tierCount),
          label: existingConfig?.label || '',
          text: existingConfig?.text || ''
        }
      })
    }

    onChange(updatedValue)
  }

  const getColorTierLabel = (index) => {
    if(index === 0) {
      return 'Min'
    }
    return `Threshold ${index}`
  }

  const calculateThresholdValue = (index, count) => {
    return 25 * (index + 1)
  }

  return (
    <div className='gap-8'>
      <Select
        label={'Color Tiers'}
        placeholder={''}
        selectedOption={field.options.find(option => option.value === (value?.customConfigs?.length || 0))}
        options={field.options}
        onChange={value => {
          updateColorCount(value)
        }}
      />
      {value.customConfigs &&
        <div className="chart-editor-border">
          {value.customConfigs?.map((customConfig, i) => {
            return (
              <TextColorInput
                key={field.id}
                label={getColorTierLabel(i)}
                value={customConfig?.value}
                color={customConfig?.color}
                text={customConfig?.text}
                textPlaceholder={'Override value'}
                showTextInput={chartType !== 'gauge'}
                disabled={false}
                colorDisabled={false}
                isPercent={streams?.allThresholdType === 'percent'}
                onChange={val => updateColorTiers(i, val)}
                theme={color}
              />
            )
          })}
        </div>
      }
    </div>
  )
}